import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardBody, Button, Form, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert'; 
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import { useUser } from '../context/UserContext';
import { useService } from '../context/ServiceContext';
import CustomPagination from '../components/CustomPagination';
import Search from '../components/Search';
import avatar from '../assets/images/avatar.png'

const Driver = () => {
    const [fields, setFields] = useState({
        is_active: true,
        can_view_price: true,
        can_view_customer: [],
        is_company: true,
    });
    const [errors, setErrors] = useState({});
    const { profile, permissions } = useAuth();
    const { createUser, editUser, getUser, user, customers, getUsers } = useUser();
    const { allServices, getAllServices } = useService();
    const { search } = useLocation();
    const { id } = useParams();
    const navigate = useNavigate();
    const params = new URLSearchParams(search);
    const page = params.get('page') ? parseInt(params.get('page')) : 1;
    const searchText = params.get('search') ? params.get('search') : '';

    const handleChange = (field, value) => {
        setFields({ ...fields, [field]: value });
    }

    const handleValidation = () => {
        let errors = {};
        let formIsValid = true;
    
        if (!fields['email']) {
          formIsValid = false;
          errors['email'] = 'Campo obrigatório.';
        }
    
        if (typeof fields['email'] !== 'undefined') {
            let lastAtPos = fields['email'].lastIndexOf('@');
            let lastDotPos = fields['email'].lastIndexOf('.');
    
            if (
                !(
                lastAtPos < lastDotPos &&
                lastAtPos > 0 &&
                fields['email'].indexOf('@@') == -1 &&
                lastDotPos > 2 &&
                fields['email'].length - lastDotPos > 2
                )
            ) {
            formIsValid = false;
            errors['email'] = 'O e-mail é inválido.';
          }
        }

        if (!fields['email']) {
            formIsValid = false;
            errors['email'] = 'Campo obrigatório.';
        }
    
        if (!id && !fields['password']) {
            formIsValid = false;
            errors['password'] = 'Campo obrigatório.';
        }
    
        setErrors(errors);
        return formIsValid;
    }

    const hasPermission = () => {
        if(
               (id  && !permissions.includes('change_user'))
            || (!id && !permissions.includes('add_user'))
        ) {
            toast.warning('Seu usuário não tem permissões o suficiente para executar essa ação.');
            return false;
        }
        return true;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (handleValidation() && hasPermission()) {
            let res;
            if(id) {
                res = await editUser(id, {...fields, username: fields.email, groups: [1]});
            } else {
                res = await createUser({...fields, username: fields.email, groups: [1]});
            }
    
            if (res.status === 201) {
                toast.success('Empresa criada com sucesso.');
                navigate(`/customers`);
            }
            else if (res.status === 200 && id) {
                toast.success('Empresa alterada com sucesso.');
                navigate(`/customers`);
            } 
            else if(res.response.status === 400) {
                if(res.response.data?.detail) toast.error(res.response.data.detail);
                else {
                    let errors = {};
                    Object.keys(res.response.data).forEach((key) => {
                        errors[key] = res.response.data[key][0];
                    })
                    setErrors(errors)
                }
            }
            else {
                toast.error('Ops! Ocorreu um erro inesperado. Tente novamente. Se o erro persistir, entre em contato com o suporte.');
            }
        }
    }

    const getData = async() => {
        getUsers(1, 1, '', true);
        getAllServices();
        if(id) {
            const res = await getUser(id);
            setFields(res.data);
        }
    }

    useEffect(() => {
        // console.log('profile', profile)
    }, ['profile'])

    useEffect(() => {
        getData();
    }, [])

    return (
        <>
            <h2 className='fs-6 fw-semibold my-4'>{!id ? 'Criar empresa' : `Editar ${user?.email}`}</h2>

            <Card>
                <CardBody>
                    <Form onSubmit={handleSubmit} noValidate>
                        <Row className='mb-4'>
                            <Col md={12}>
                                <FormGroup>
                                    <Label check htmlFor='first_name'>Nome</Label>
                                    <Input
                                    type='text'
                                    id='first_name'
                                    name='first_name'
                                    value={fields?.first_name}
                                    invalid={errors?.first_name}
                                    onChange={(e) => handleChange('first_name', e.target.value)}
                                    />
                                    <FormFeedback>{errors?.first_name}</FormFeedback>
                                </FormGroup>
                            </Col>
                            {/* <Col md={6}>
                                <FormGroup>
                                    <Label check htmlFor='last_name'>Sobrenome</Label>
                                    <Input
                                    type='text'
                                    id='last_name'
                                    name='last_name'
                                    value={fields?.last_name}
                                    invalid={errors?.last_name}
                                    onChange={(e) => handleChange('last_name', e.target.value)}
                                    />
                                    <FormFeedback>{errors?.last_name}</FormFeedback>
                                </FormGroup>
                            </Col> */}
                            <Col md={6}>
                                <FormGroup>
                                    <Label check htmlFor='email'>E-mail</Label>
                                    <Input
                                    type='email'
                                    id='email'
                                    name='email'
                                    value={fields?.email}
                                    invalid={errors?.email}
                                    onChange={(e) => handleChange('email', e.target.value)}
                                    />
                                    <FormFeedback>{errors?.email}</FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label check htmlFor='password'>Senha</Label>
                                    <Input
                                    type='password'
                                    id='password'
                                    name='password'
                                    placeholder={!id ? '' : '******'}
                                    value={fields?.password}
                                    invalid={errors?.password}
                                    onChange={(e) => handleChange('password', e.target.value)}
                                    />
                                    <FormFeedback>{errors?.password}</FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col md={12}>
                                <Label>&nbsp;</Label>
                                <FormGroup check>
                                    <Input
                                        id="is_active"
                                        type="checkbox"
                                        checked={fields.is_active}
                                        onChange={(e) => handleChange('is_active', e.target.checked ? true : false)}
                                    />
                                    {' '}
                                    <Label check htmlFor='is_active'>Ativo</Label>
                                </FormGroup>
                            </Col>
                            <Col md={12}>
                                <FormGroup check>
                                    <Input
                                        id="can_view_price"
                                        type="checkbox"
                                        checked={fields.can_view_price}
                                        onChange={(e) => handleChange('can_view_price', e.target.checked ? true : false)}
                                    />
                                    {' '}
                                    <Label check htmlFor='can_view_price'>Pode visualizar preço</Label>
                                </FormGroup>
                            </Col>
                            <Col md={12}>
                                <FormGroup check>
                                    <Input
                                        id="can_add_user"
                                        type="checkbox"
                                        checked={fields.can_add_user}
                                        onChange={(e) => handleChange('can_add_user', e.target.checked ? true : false)}
                                    />
                                    {' '}
                                    <Label check htmlFor='can_add_user'>Pode criar usuário</Label>
                                </FormGroup>
                            </Col>
                            <Col md={12} className='mt-4 mb-3'>
                                <Label check htmlFor='password'>Empresas</Label>
                                <Card className='border' style={{boxShadow: 'none'}}>
                                    <CardBody>
                                        {customers?.map((customer, key) => {
                                            return (
                                                parseInt(id) !== customer.id ?
                                                <FormGroup key={key} check>
                                                    <Input
                                                        id={"can_view_customer_" + customer.id}
                                                        type="checkbox"
                                                        checked={fields?.can_view_customer?.includes(customer.id)}
                                                        onChange={(e) => {
                                                            let can_view_customer = [...fields.can_view_customer]
                                                            if(e.target.checked) {
                                                                can_view_customer.push(customer.id)
                                                            } else {
                                                                can_view_customer = can_view_customer.filter((item) => item !== customer.id)
                                                            }
                                                            setFields({ ...fields, 'can_view_customer': can_view_customer});
                                                        }}
                                                    />
                                                    {' '}
                                                    <Label check htmlFor={"can_view_customer_" + customer.id}>{customer.first_name +' '+ customer.last_name}</Label>
                                                </FormGroup>
                                                : null
                                            )
                                        })}
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col md={12} className='mt-4 mb-3'>
                                <Label check htmlFor='password'>Serviços</Label>
                                <Card className='border' style={{boxShadow: 'none'}}>
                                    <CardBody>
                                        {allServices?.map((service, key) => {
                                            return (
                                                <FormGroup key={key} check>
                                                    <Input
                                                        id={"service_" + service.id}
                                                        type="checkbox"
                                                        checked={fields?.services?.includes(service.id)}
                                                        onChange={(e) => {
                                                            let services = [...fields.services]
                                                            if(e.target.checked) {
                                                                services.push(service.id)
                                                            } else {
                                                                services = services.filter((item) => item !== service.id)
                                                            }
                                                            setFields({ ...fields, 'services': services});
                                                        }}
                                                    />
                                                    {' '}
                                                    <Label check htmlFor={"service_" + service.id}>{service.name}</Label>
                                                </FormGroup>
                                            )
                                        })}
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        {id === undefined && permissions.includes('add_user') ? 
                            <Button color='primary'>Adicionar</Button> 
                        : null}

                        {id && permissions.includes('change_user') ? 
                            <Button color='primary'>Guardar</Button> 
                        : null}
                    </Form>
                </CardBody>
            </Card>
        </>
    )
};
  
export default Driver;